jQuery(document).ready( function($) {

    //$('#btn-menu').prepend('<div class="c-hamburger c-hamburger--htx"><span>Toggle Navigation</span></div>');
    //$('#nav-menu').addClass('loaded');

    //new Mmenu(document.querySelector("#nav-menu"));


    $('.c-hamburger').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('nav-panels--open');

        if ($('.c-hamburger').css('display') !== 'none') { //hamburger is visible
            $('.nav-panel').css('transition', 'transform .5s');
        } else {
            $('.nav-panel').css('transition', 'none!important');
        }
    });

    /*$('.main-carousel').flickity({
        cellAlign: 'center',
        imagesLoaded: true,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        selectedAttraction: 0.1,
        friction: 0.8,
    });*/


    function doresize() {
        $('body').removeClass('nav-panels--open');
        //if ($('.c-hamburger').css('display') !== 'none') { //hamburger is visible
            //$('.nav-panel').css('transition', 'transform .5s');
        //} else {
            //$('.nav-panel').css('transition', 'none!important');
        //}
    }

    doresize();
    window.onresize = doresize;

    /*
    function stickynav() {
        let scrolltop = $(window).scrollTop(); //current vertical position from the top
        if (scrolltop > 50) {
            $('body').addClass('sticky');
        } else {
            $('body').removeClass('sticky');
        }
    }
    stickynav();

    $(window).scroll(function() {
        stickynav();
    });
    */


});